// src/components/common/Button.js
import React from 'react';

export const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'md', 
  className = '',
  fullWidth = false,
  rounded = 'md',
  disabled = false
}) => {
  // Compute variant classes
  const variantClasses = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700',
    secondary: 'bg-gray-200 text-blue-600 hover:bg-gray-300',
    outline: 'bg-transparent border border-blue-600 text-blue-600 hover:bg-blue-50',
    ghost: 'bg-transparent text-blue-600 hover:bg-blue-50',
  };

  // Compute size classes
  const sizeClasses = {
    sm: 'py-1 px-3 text-sm',
    md: 'py-2 px-4',
    lg: 'py-3 px-6 text-lg',
  };

  // Compute rounded classes
  const roundedClasses = {
    none: 'rounded-none',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    full: 'rounded-full',
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        font-medium transition-colors duration-200 
        ${variantClasses[variant]} 
        ${sizeClasses[size]} 
        ${roundedClasses[rounded]}
        ${fullWidth ? 'w-full' : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export const TabButton = ({ title, isActive, onClick }) => {
  return (
    <button 
      className={`flex-1 py-2 text-center text-sm font-medium rounded-lg ${
        isActive 
          ? 'bg-blue-600 text-white' 
          : 'text-gray-700'
      }`}
      onClick={onClick}
    >
      {title}
    </button>
  );
};